import { useMemo } from 'react'
import icons from './icons'
import { VERTICAL_ROUTE_MAP } from '../../config/verticalRoutes'
import { useSelector } from 'react-redux'
import { selectCurrentUser, selectShowDataScience } from '../../store/global'
import userService from '../../services/user'
import { useEnabledVerticalIds } from '../../services/verticalsQueryService'

interface NavigationLink {
  title: string
  path: string
  iconUrl?: string
  onClick?: () => void
  isDisplayed?: <T>(user?: T) => boolean
}

export const useNavigationLinks = () => {
  const currentUser = useSelector(selectCurrentUser)
  const { enabledVerticalIds: enabledVerticalIdsArr } = useEnabledVerticalIds()
  const showDataScience = useSelector(selectShowDataScience)

  const isManagementDisplayed = !userService.isBasicUser(currentUser)

  return useMemo(() => {
    const enabledVerticalIdsSet = new Set(enabledVerticalIdsArr)
    const staticLinks: NavigationLink[] = [
      {
        title: 'Dashboard',
        path: '/dashboard',
        iconUrl: icons.dashboardIconUrl,
      },
    ]

    const verticalLinks: NavigationLink[] = Object.values(VERTICAL_ROUTE_MAP)
      .filter(config => {
        const checkId = config.id
        return enabledVerticalIdsSet.has(checkId)
      })
      .map(config => ({
        title: config.title,
        path: config.path,
        iconUrl: (icons as Record<string, string>)[config.iconKey],
      }))

    const dataScienceLink: NavigationLink | null = showDataScience
      ? {
          title: 'Data Science',
          path: '/data-science',
          iconUrl: icons.dataScienceIconUrl,
        }
      : null

    const managementLink: NavigationLink = {
      title: 'Management',
      path: '/management',
      iconUrl: icons.managementIconUrl,
      isDisplayed: () => isManagementDisplayed,
    }

    return [...staticLinks, ...verticalLinks, ...(dataScienceLink ? [dataScienceLink] : []), managementLink].filter(
      ({ isDisplayed = () => true }) => isDisplayed<typeof currentUser>(currentUser),
    )
  }, [enabledVerticalIdsArr, showDataScience, isManagementDisplayed, currentUser])
}
